import {
  GET_ROOM_TYPE_REQUEST,
  GET_ROOM_TYPE_SUCCESS,
  GET_ROOM_TYPE_FAILURE,
  POST_ROOM_TYPE_REQUEST,
  POST_ROOM_TYPE_SUCCESS,
  POST_ROOM_TYPE_FAILURE,
  DELETE_ROOM_TYPE_REQUEST,
  DELETE_ROOM_TYPE_SUCCESS,
  DELETE_ROOM_TYPE_FAILURE,
  PATCH_ROOM_TYPE_FAILURE,
  PATCH_ROOM_TYPE_SUCCESS,
  PATCH_ROOM_TYPE_REQUEST,
  RESET_ROOM_TYPE_FLAGS,
  GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST,
  GET_ALL_ROOM_NUMBER_WITH_ID_SUCCESS,
  GET_ALL_ROOM_NUMBER_WITH_ID_FAILURE,
  GET_ALL_ROOM_TYPE_WITH_ID_REQUEST,
  GET_ALL_ROOM_TYPE_WITH_ID_SUCCESS,
  GET_ALL_ROOM_TYPE_WITH_ID_FAILURE,
  GET_ROOM_TYPE_NAME_REQUEST,
  GET_ROOM_TYPE_NAME_SUCCESS,
  GET_ROOM_TYPE_NAME_FAILURE,
  GET_ROOM_STATUS_REQUEST,
  GET_ROOM_STATUS_SUCCESS,
  GET_ROOM_STATUS_FAILURE,
  GET_ROOM_LIST_FAILURE,GET_ROOM_LIST_REQUEST,GET_ROOM_LIST_SUCCESS
} from "../../../Utils/Constant";

const initialState = {
  roomTypes: {},   
  roomTypeName:{},   
  bookingstatus:{},
  roomTypeWithId:{},
  loading: false,     
  error: null,   
  roomTypeCreated: false,
  roomTypeUpdated: false,
  deleteSuccess: false,
  roomList:{}
};

export const roomTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET ROOM TYPES
    case GET_ROOM_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        roomTypes: action.payload,
        loading: false,
        error: null,
      };
    case GET_ROOM_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
//room type names
      case GET_ROOM_TYPE_NAME_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_ROOM_TYPE_NAME_SUCCESS:
        return {
          ...state,
          roomTypeName: action.payload,
          loading: false,
          error: null,
        };
      case GET_ROOM_TYPE_NAME_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };


//room type status
      case GET_ROOM_STATUS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_ROOM_STATUS_SUCCESS:
        return {
          ...state,
          bookingstatus: action.payload,
          loading: false,
          error: null,
        };
      case GET_ROOM_STATUS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

    // POST ROOM TYPE
    case POST_ROOM_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        roomTypeCreated: true,
        loading: false,
        error: null,
      };
    case POST_ROOM_TYPE_FAILURE:
      return {
        ...state,
        roomTypeCreated: false,
        loading: false,
        error: action.payload,
      };

    // DELETE ROOM TYPE
    case DELETE_ROOM_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
        error: null,
      };
    case DELETE_ROOM_TYPE_FAILURE:
      return {
        ...state,
        deleteSuccess: false,
        loading: false,
        error: action.payload,
      };

    case PATCH_ROOM_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PATCH_ROOM_TYPE_SUCCESS:
      return {
        ...state,
        roomTypeUpdated: true,
        loading: false,
        error: null,
      };
    case PATCH_ROOM_TYPE_FAILURE:
      return {
        ...state,
        roomTypeUpdated: false,
        loading: false,
        error: action.payload,
      };

    case RESET_ROOM_TYPE_FLAGS:
      return {
        ...state,
        roomTypeCreated: false,
        roomTypeUpdated: false,
        deleteSuccess: false,
        error: null,
      };

    // Get All Room Number With ID
    case GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_ROOM_NUMBER_WITH_ID_SUCCESS:
      return {
        ...state,
        roomNumber: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_ROOM_NUMBER_WITH_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

      // Get All Room Type With ID
    case GET_ALL_ROOM_TYPE_WITH_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_ROOM_TYPE_WITH_ID_SUCCESS:
      return {
        ...state,
        roomTypeWithId: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_ROOM_TYPE_WITH_ID_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

      case GET_ROOM_LIST_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_ROOM_LIST_SUCCESS:
        return {
          ...state,
          roomList: action.payload,
          loading: false,
          error: null,
        };
      case GET_ROOM_LIST_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };

    default:
      return state;
  }
};
